var shadows = {
  xs: '0 1px 2px 0 rgba(63,62,75,0.20)',
  sm: '0 1px 2px 0 rgba(63,62,75,0.20), 0 1px 3px 0 rgba(63,62,75,0.10)',
  md: '0 3px 6px 0 rgba(63,62,75,0.08), 0 6px 12px 0 rgba(63,62,75,0.20)',
  lg: '0 6px 6px 0 rgba(63,62,75,0.20), 0 10px 20px 0 rgba(63,62,75,0.20)',
  xl: '0 10px 10px 0 rgba(63,62,75,0.24), 0 14px 28px 0 rgba(63,62,75,0.16)'
};
var shadows$1 = shadows;
export { shadows$1 as default };